/* Product Custom Scripts - Extracted from PDP HTML */

document.addEventListener('DOMContentLoaded', function() {
  // 1. Hot Sale terms popup (TEMPORAL - ELIMINAR DESPUÉS DEL 2 DE JUNIO)
  /*
  document.addEventListener('click', function(event) {
    const target = event.target;
    
    // Show popup
    if (target.closest('[data-action="show-hot-sale-terms"]')) {
      event.preventDefault();
      const popup = document.getElementById('hotSaleTermsPopup');
      if (popup) {
        popup.classList.add('is-visible');
        document.body.classList.add('hot-sale-popup-open');
      }
    }
    
    // Close popup
    if (target.closest('[data-action="close-hot-sale-terms"]')) {
      event.preventDefault();
      const popup = document.getElementById('hotSaleTermsPopup');
      if (popup) {
        popup.classList.remove('is-visible');
        document.body.classList.remove('hot-sale-popup-open');
      }
    }
  });
  */

  // 2. Gateway Terms popup & Profile Terms Popup
  document.addEventListener('click', function(event) {
    const target = event.target;
    
    // Show gateway popup
    if (target.closest('[data-action="show-terms"]')) {
      event.preventDefault();
      const popup = document.getElementById('gatewayTermsPopup');
      if (popup) popup.classList.add('is-visible');
    }
    
    // Close gateway popup
    if (target.closest('[data-action="close-terms"]')) {
      event.preventDefault();
      const popup = document.getElementById('gatewayTermsPopup');
      if (popup) popup.classList.remove('is-visible');
    }

    // Show profile terms popup
    if (target.closest('[data-action="show-profile-terms"]')) {
      event.preventDefault();
      const popup = document.getElementById('profileTermsPopup');
      if (popup) popup.classList.add('is-visible');
    }
    
    // Close profile terms popup
    if (target.closest('[data-action="close-profile-terms"]')) {
      event.preventDefault();
      const popup = document.getElementById('profileTermsPopup');
      if (popup) popup.classList.remove('is-visible');
    }
  });

  // 3. Perfil Select (Espejeado/Color)
  var perfilSelect = document.getElementById('perfil');
  var colorInput = document.getElementById('color');

  if (perfilSelect && colorInput) {
    perfilSelect.addEventListener('change', function () {
      var perfil = perfilSelect.value;
      if (perfil === 'Espejeado') {
        colorInput.style.display = 'none';
        colorInput.value = 'ninguno';
        colorInput.required = false;
        colorInput.disabled = true;
      } else {
        colorInput.style.display = '';
        colorInput.value = '#000000';
        colorInput.required = true;
        colorInput.disabled = false;
      }
    });

    // Trigger the change event on page load to set the initial state of the color picker
    perfilSelect.dispatchEvent(new Event('change'));
  }
});

/*
 * Fila de opciones con scroll horizontal (móvil): al cargar, deja a la vista
 * la opción ya seleccionada (la variante de la URL) centrada en la fila, con
 * las vecinas asomando a los lados. Sólo mueve el scroll de la fila, nunca el
 * de la página. Si la fila no desborda, no hace nada.
 */
(function () {
  'use strict';

  function revealSelected(list) {
    var checked = list.querySelector('input[type="radio"]:checked');
    if (!checked) {
      return;
    }
    var item = checked.closest('.block-swatch') || checked.parentElement;
    if (!item || list.scrollWidth <= list.clientWidth + 1) {
      return;
    }
    var listRect = list.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    var itemLeft = itemRect.left - listRect.left + list.scrollLeft;
    var target = itemLeft - (list.clientWidth - itemRect.width) / 2;
    var max = list.scrollWidth - list.clientWidth;
    list.scrollLeft = Math.max(0, Math.min(target, max));
  }

  function revealAll() {
    var lists = document.querySelectorAll('.product-form__variants .block-swatch-list');
    for (var i = 0; i < lists.length; i++) {
      revealSelected(lists[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealAll);
  } else {
    revealAll();
  }
  // Las fuentes y los anchos de los pills terminan de asentarse en load.
  window.addEventListener('load', revealAll);
})();
